@if (isMiddleOfficeAvailable()) {
  @switch (currentActionType()) {
    @case ("DISCONNECT") {
      <div class="centered-with-padding flex justify-center py-2.5 desk:justify-start">
        <button
          (click)="executeCurrentAction()"
          type="button"
          class="flex w-full cursor-pointer items-center justify-center gap-x-2.5 rounded-xl bg-error px-5 py-2.5 font-semibold uppercase text-white shadow-sm transition-all duration-300 hover:ring-2 hover:ring-error/50 hover:ring-offset-2 desk:w-fit">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5.636 5.636a9 9 0 1 0 12.728 0M12 3v9" />
          </svg>
          <span> {{ "MIDDLE_OFFICE.LOGOUT" | translate }}</span>
        </button>
      </div>
    }
    @case ("EDIT") {
      <div [class]="styleClass()">
        <button
          (click)="executeCurrentAction()"
          type="button"
          class="flex w-full cursor-pointer items-center justify-center rounded-xl bg-blue p-2.5 font-semibold uppercase text-white shadow-sm transition-all duration-300 hover:ring-2 hover:ring-blue/50 hover:ring-offset-2 desk:w-fit">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="size-6">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
          </svg>
        </button>
      </div>
    }
    @case ("ADD") {
      <div [class]="styleClass()">
        <button
          (click)="executeCurrentAction()"
          type="button"
          class="flex w-full cursor-pointer items-center justify-center rounded-xl bg-blue p-2.5 font-semibold uppercase text-white shadow-sm transition-all duration-300 hover:ring-2 hover:ring-blue/50 hover:ring-offset-2 desk:w-fit">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>
        </button>
      </div>
    }
  }
}
<dialog #dialogRef class="fixed inset-0 m-0 h-screen max-h-none w-screen max-w-none rounded-none border-0 p-0">
  @if (iframeUrl(); as url) {
    <iframe title="Middle office" [src]="url | safeResourceUrl" class="size-full"></iframe>
  }
</dialog>
